/**
 * @generated SignedSource<<703214d4fd92fb76545618df9db203e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateInitialSearchResultsContentfulRelayQuery$variables = {
  categoryUrlSlugs: ReadonlyArray<string>;
  limit: number;
  locale: string;
  skip: number;
  templateIds: ReadonlyArray<string>;
  urlSlugs: ReadonlyArray<string>;
};
export type templateInitialSearchResultsContentfulRelayQuery$data = {
  readonly initialSearchResults: {
    readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsContentfulRelayRefetchableFragment">;
  };
};
export type templateInitialSearchResultsContentfulRelayQuery = {
  response: templateInitialSearchResultsContentfulRelayQuery$data;
  variables: templateInitialSearchResultsContentfulRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryUrlSlugs"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlugs"
},
v6 = {
  "kind": "Variable",
  "name": "limit",
  "variableName": "limit"
},
v7 = {
  "kind": "Variable",
  "name": "locale",
  "variableName": "locale"
},
v8 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateInitialSearchResultsContentfulRelayQuery",
    "selections": [
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "categoryUrlSlugs",
                  "variableName": "categoryUrlSlugs"
                },
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                {
                  "kind": "Variable",
                  "name": "templateIds",
                  "variableName": "templateIds"
                },
                {
                  "kind": "Variable",
                  "name": "urlSlugs",
                  "variableName": "urlSlugs"
                }
              ],
              "kind": "FragmentSpread",
              "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment"
            }
          ],
          "type": "Query",
          "abstractKey": null
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "initialSearchResults"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "templateInitialSearchResultsContentfulRelayQuery",
    "selections": [
      {
        "alias": "templates",
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "fields": [
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "urlSlug_in",
                        "variableName": "urlSlugs"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "OR.0"
                  },
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "id_in",
                            "variableName": "templateIds"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "sys"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "OR.1"
                  },
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "urlSlug_in",
                            "variableName": "categoryUrlSlugs"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "category"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "OR.2"
                  }
                ],
                "kind": "ListValue",
                "name": "OR"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplate",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                  }
                ],
                "concreteType": "ProductTemplateProductCollection",
                "kind": "LinkedField",
                "name": "productCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductListing",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductName",
                        "kind": "LinkedField",
                        "name": "productNameReference",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productNameId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "productCollection(limit:1)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateNameExternal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlSlug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pluginModuleKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previewBlurb",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateTypeCollection",
                "kind": "LinkedField",
                "name": "templateTypeCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateTypeNameExternal",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyNameInternal",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Author",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "CompanyNameInternal",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e928119e639c68d84d6c2d68d0017fd9",
    "id": null,
    "metadata": {},
    "name": "templateInitialSearchResultsContentfulRelayQuery",
    "operationKind": "query",
    "text": "query templateInitialSearchResultsContentfulRelayQuery(\n  $urlSlugs: [String!]!\n  $templateIds: [String!]!\n  $categoryUrlSlugs: [String!]!\n  $limit: Int!\n  $skip: Int!\n  $locale: String!\n) {\n  ...templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P on Query {\n  templates: productTemplateCollection(limit: $limit, skip: $skip, locale: $locale, where: {OR: [{urlSlug_in: $urlSlugs}, {sys: {id_in: $templateIds}}, {category: {urlSlug_in: $categoryUrlSlugs}}]}) {\n    items {\n      sys {\n        id\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      templateNameExternal\n      urlSlug\n      ...templateCardContentfulRelayFragment\n    }\n    total\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a051c0ee28540a725e60d886cd79ce5";

export default node;
